import { context } from '@nbx/frontend-helpers/auth';
import { fetchMarkets, formatMarkets, getMarketsBaseUrl } from '@nbx/frontend-helpers/repository';
import type { Market } from '@nbx/frontend-helpers/repository';
import type { MarketsFromJWT } from '@nbx/frontend-helpers/types';

export type { Market, MarketMode } from '@nbx/frontend-helpers/repository';

export async function fetchAndFormatMarkets(
  marketsFromJWT: MarketsFromJWT = {},
  accountToken?: string
): Promise<Array<Market>> {
  return formatMarkets(await NBXMarkets.getMarkets(accountToken), marketsFromJWT);
}

const NBXMarkets = {
  // TODO: I don't love this
  getBaseUrl: getMarketsBaseUrl,

  getMarkets: async (accountToken?: string): Promise<Array<Market>> => {
    let accountContext;
    if (!accountToken) {
      try {
        accountContext = await context.account();
      } catch (error) {
        console.warn('failed to get account context, fetching public markets', error);
      }
    } else {
      accountContext = { token: accountToken };
    }
    return fetchMarkets(accountContext);
  }
};

export default NBXMarkets;
